import PropTypes from 'prop-types'
import React from 'react'

export const AddAddressBtn = ({onClick}) =>
  <a className='dodaj-model-btn' href='javascript:void(0)' onClick={onClick}>
    <span className='add-model'>[+]</span> Dodaj još adresa
  </a>

AddAddressBtn.propTypes = {
  onClick: PropTypes.func
}
